import React from 'react';
import PropTypes from 'prop-types';

// Components
import CompareTableRow from '@/braun/components/molecules/CompareTableRow';

const CompareTableBody = ({ titles, featureValues }) => {
  const tableRows = featureValues.map((features, i) => {
    const isFirstProduct = i === 0;
    return (
      <CompareTableRow
        key={`compare-table-row-${titles[i]}`}
        isFirstProduct={isFirstProduct}
        features={features}
        titles={titles}
      />
    );
  });

  return <tbody className='bra-comparsionTable__body'>{tableRows}</tbody>;
};

CompareTableBody.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  featureValues: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
};

export default CompareTableBody;
